import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-[#E31E24] pt-12 sm:pt-16 md:pt-20 pb-6 sm:pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-16">
          {/* Column 1 - About */}
          <div className="col-span-2 lg:col-span-2">
            <img 
              src="https://static.readdy.ai/image/26c3401126eecf15eb2286ded28883ff/289e4af9c1f47a64ff4db8c7e8c98e4a.jpeg" 
              alt="Metamorfosi Preparazioni Logo" 
              className="h-12 sm:h-14 md:h-16 w-auto mb-4 md:mb-6"
            />
            <p className="text-white/90 text-xs sm:text-sm leading-relaxed mb-4 md:mb-6 max-w-md">
              Officina mobile specializzata in manutenzioni ordinarie di auto e moto a domicilio. Professionalità, convenienza e qualità direttamente dove vuoi.
            </p>
            <div className="flex items-center space-x-3 sm:space-x-4">
              <a href="https://wa.me/393518312394" target="_blank" rel="noopener noreferrer" className="w-9 sm:w-10 h-9 sm:h-10 rounded-full bg-white/10 hover:bg-white flex items-center justify-center transition-all duration-300 group cursor-pointer">
                <i className="ri-whatsapp-line text-white group-hover:text-[#E31E24] text-lg sm:text-xl"></i>
              </a>
              <a href="mailto:info@metamorfosipreparazioni.it" className="w-9 sm:w-10 h-9 sm:h-10 rounded-full bg-white/10 hover:bg-white flex items-center justify-center transition-all duration-300 group cursor-pointer">
                <i className="ri-mail-line text-white group-hover:text-[#E31E24] text-lg sm:text-xl"></i>
              </a>
              <a href="tel:+393518312394" className="w-9 sm:w-10 h-9 sm:h-10 rounded-full bg-white/10 hover:bg-white flex items-center justify-center transition-all duration-300 group cursor-pointer">
                <i className="ri-phone-line text-white group-hover:text-[#E31E24] text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h4 className="text-white font-bold text-xs sm:text-sm uppercase tracking-wider mb-4 md:mb-6">
              Navigazione
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button onClick={scrollToTop} className="text-white/80 hover:text-white text-xs sm:text-sm transition-colors duration-300 cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('servizi')} className="text-white/80 hover:text-white text-xs sm:text-sm transition-colors duration-300 cursor-pointer">
                  Servizi
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('chi-siamo')} className="text-white/80 hover:text-white text-xs sm:text-sm transition-colors duration-300 cursor-pointer">
                  Chi Siamo
                </button>
              </li>
              <li>
                <Link to="/zone-servite" className="text-white/80 hover:text-white text-xs sm:text-sm transition-colors duration-300 cursor-pointer">
                  Zona Operativa
                </Link>
              </li>
              <li>
                <button onClick={() => scrollToSection('contatti')} className="text-white/80 hover:text-white text-xs sm:text-sm transition-colors duration-300 cursor-pointer">
                  Contatti
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div>
            <h4 className="text-white font-bold text-xs sm:text-sm uppercase tracking-wider mb-4 md:mb-6">
              Contatti
            </h4>
            <ul className="space-y-3 sm:space-y-4">
              <li>
                <a href="tel:+393518312394" className="text-white/80 hover:text-white text-xs sm:text-sm transition-colors duration-300 cursor-pointer flex items-center">
                  <i className="ri-phone-line mr-2"></i>
                  <span>+39 351 831 2394</span>
                </a>
              </li>
              <li>
                <a href="mailto:metamorfosi.preparazioni@gmail.com" className="text-white/80 hover:text-white text-xs sm:text-sm transition-colors duration-300 cursor-pointer flex items-start">
                  <i className="ri-mail-line mr-2 mt-0.5"></i>
                  <span>metamorfosi.preparazioni@gmail.com</span>
                </a>
              </li>
              <li className="text-white/80 text-xs sm:text-sm flex items-start">
                <i className="ri-time-line mr-2 mt-0.5"></i>
                <div>
                  <p>Lun-Ven: 8:00-19:00</p>
                  <p>Sab: 8:00-13:00</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-6 md:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
            <p className="text-white/70 text-xs sm:text-sm text-center sm:text-left">
              © 2025 Metamorfosi Preparazioni. Tutti i diritti riservati.
            </p>
            <div className="flex items-center space-x-6">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white text-xs sm:text-sm transition-colors duration-300 cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
